import { render, staticRenderFns } from "./ReportBuilderEdit.vue?vue&type=template&id=583e3fd0&"
import script from "./ReportBuilderEdit.vue?vue&type=script&lang=ts&"
export * from "./ReportBuilderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports